import React from 'react';
import ClearLogoBlack from 'assets/icons/clear.svg';
import SearchLogoBlack from 'assets/icons/search-black.svg';

interface ISearchBar {
  setSearchedTerm: (value: string) => void;
  searchedTerm: string;
  placeholder?: string;
}

export default function SearchBar({
  setSearchedTerm,
  searchedTerm,
  placeholder,
}: ISearchBar) {
  function handleClearSearch() {
    setSearchedTerm('');
  }

  return (
    <div className="search-bar">
      <input
        type="text"
        className="search-bar-input"
        placeholder={placeholder || 'Search by keyword…'}
        value={searchedTerm}
        onChange={e => setSearchedTerm(e.target.value)}
      />
      <div className="search-bar-btn">
        {searchedTerm ? (
          <img
            alt="settings"
            src={ClearLogoBlack}
            className="search-logo"
            onClick={() => handleClearSearch()}
          />
        ) : (
          <img alt="settings" className="search-logo" src={SearchLogoBlack} />
        )}
      </div>
    </div>
  );
}
